import { Instance, SnapshotOut, types } from "mobx-state-tree";

export const CustomPlaceholderModel = types.model("CustomPlaceholderModel", {
  displayName: types.string,
  placeholder: types.string,
});

export const createCustomPlaceholderModel = (
  customPlaceholder: SnapshotOut<typeof CustomPlaceholderModel>,
): Instance<typeof CustomPlaceholderModel> =>
  CustomPlaceholderModel.create(customPlaceholder);
